/**
 * Single source of truth for which check settings sections exist. Order matches
 * the single-element detail pane's check settings tabs. Add a section by adding
 * a key here — `CHECK_SETTINGS_TAB_DEFINITIONS` (MultiEditCheckSettingsTabs/tabs.tsx)
 * type-checks its `key` fields against this list, and useIsAnyCheckSettingsSectionBlocked
 * derives its blocked-check from it directly, so nothing else needs updating by hand.
 */
export const CHECK_SETTINGS_SECTION_KEYS = [
  'supportCompression',
  'hotDimensioning',
  'vibration',
  'steelConfig',
  'shearCheck',
] as const

export type CheckSettingsSectionKey = typeof CHECK_SETTINGS_SECTION_KEYS[number]

/**
 * Block action id for one check settings multi-edit section's dirty-blocker.
 * Scoped per section (rather than one id shared by every tab) so the block
 * doesn't depend on the tabs component keeping only one panel mounted at a time.
 * Takes a plain `string` (rather than `CheckSettingsSectionKey`) because
 * `MultiEditCheckSettingsTabs` also calls this with a '' placeholder before any
 * tab has resolved.
 */
export const checkSettingsBlockAction = (sectionKey: CheckSettingsSectionKey | ''): string =>
  `multi-edit-check-settings-${sectionKey}`
